import Link from 'next/link'

import { decodeSafeEntities } from '@/lib/sanitise-strings'

type TableLinkProps = {
  title: string
  link: string
}

export function TableLink({ title, link }: TableLinkProps) {
  return (
    <Link href={link} className="text-primary hover:text-grey-950">
      {title ? decodeSafeEntities(title) : ''}
    </Link>
  )
}
